/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { UpdateTranscriptionWordsFragmentDetailMutationRequest, UpdateTranscriptionWordsFragmentDetailMutationResponse, UpdateTranscriptionWordsFragmentDetailPathParams, UpdateTranscriptionWordsFragmentDetail404 } from "../models/UpdateTranscriptionWordsFragmentDetail";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { updateTranscriptionWordsFragmentDetail } from "../axios/updateTranscriptionWordsFragmentDetail";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const updateTranscriptionWordsFragmentDetailMutationKey = () => ["web-app-bff-api", { url: '/fragments/:id/transcription/words' }] as const

export type UpdateTranscriptionWordsFragmentDetailMutationKey = ReturnType<typeof updateTranscriptionWordsFragmentDetailMutationKey>

export function updateTranscriptionWordsFragmentDetailMutationOptions<TContext = unknown>(config: Partial<RequestConfig<UpdateTranscriptionWordsFragmentDetailMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = updateTranscriptionWordsFragmentDetailMutationKey()
        return mutationOptions<UpdateTranscriptionWordsFragmentDetailMutationResponse, ResponseErrorConfig<UpdateTranscriptionWordsFragmentDetail404>, {id: UpdateTranscriptionWordsFragmentDetailPathParams["id"], data: UpdateTranscriptionWordsFragmentDetailMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return updateTranscriptionWordsFragmentDetail(id, data, config)
          },
        })

}

/**
 * @summary Replace fragment transcription words
 * {@link /fragments/:id/transcription/words}
 */
export function useUpdateTranscriptionWordsFragmentDetail<TContext>(options: 
{
  mutation?: UseMutationOptions<UpdateTranscriptionWordsFragmentDetailMutationResponse, ResponseErrorConfig<UpdateTranscriptionWordsFragmentDetail404>, {id: UpdateTranscriptionWordsFragmentDetailPathParams["id"], data: UpdateTranscriptionWordsFragmentDetailMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<UpdateTranscriptionWordsFragmentDetailMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? updateTranscriptionWordsFragmentDetailMutationKey()

          const baseOptions = updateTranscriptionWordsFragmentDetailMutationOptions(config) as UseMutationOptions<UpdateTranscriptionWordsFragmentDetailMutationResponse, ResponseErrorConfig<UpdateTranscriptionWordsFragmentDetail404>, {id: UpdateTranscriptionWordsFragmentDetailPathParams["id"], data: UpdateTranscriptionWordsFragmentDetailMutationRequest}, TContext>
          

          return useMutation<UpdateTranscriptionWordsFragmentDetailMutationResponse, ResponseErrorConfig<UpdateTranscriptionWordsFragmentDetail404>, {id: UpdateTranscriptionWordsFragmentDetailPathParams["id"], data: UpdateTranscriptionWordsFragmentDetailMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<UpdateTranscriptionWordsFragmentDetailMutationResponse, ResponseErrorConfig<UpdateTranscriptionWordsFragmentDetail404>, {id: UpdateTranscriptionWordsFragmentDetailPathParams["id"], data: UpdateTranscriptionWordsFragmentDetailMutationRequest}, TContext>
      
}